import React from 'react';
import { CardActionArea as MuiCardActionArea } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCardActionArea = styled(MuiCardActionArea, {
  shouldForwardProp: (prop: any) => prop !== 'direction',
})(({ theme, direction = 'column' }: any) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  position: 'relative',
  flexDirection: direction === 'row' ? 'column' : 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

function CardActionArea({ children, ...props }: any) {
  return <StyledCardActionArea {...props}>{children}</StyledCardActionArea>;
}

export default CardActionArea;
